import React, { useEffect, useState } from "react";
import MY_PHOTO from "../assets/mine.png";
import { Link } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";
import { FaArrowDown, FaGithub } from "react-icons/fa";
import { HiOutlineDocumentDownload } from "react-icons/hi";

const ROLES = [
  "Software Engineer",
  "Backend & Systems Developer",
  "AI / LLM Engineer",
  "Cloud & DevOps Engineer",
];

const Home = () => {
  const [roleIndex, setRoleIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRoleIndex((prev) => (prev + 1) % ROLES.length);
    }, 2600);
    return () => window.clearInterval(timer);
  }, []);

  return (
    <section name="Home" className="aurora-section min-h-screen w-full">
      <div className="relative mx-auto flex min-h-screen max-w-6xl items-center px-6 pb-16 pt-28 md:pt-24">
        <div className="grid w-full items-center gap-14 md:grid-cols-[1.2fr_0.8fr]">
          {/* LEFT: TEXT */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-indigo-600 dark:text-indigo-400">
              Available for new opportunities
            </p>

            <h1 className="mt-4 text-4xl font-extrabold leading-[1.1] text-slate-900 dark:text-white sm:text-5xl md:text-6xl">
              Hi, I'm Aakash Anand
            </h1>

            <div className="mt-4 h-9 overflow-hidden text-xl font-semibold text-slate-600 dark:text-zinc-300 md:text-2xl">
              <AnimatePresence mode="wait">
                <motion.p
                  key={ROLES[roleIndex]}
                  initial={{ opacity: 0, y: 14 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -14 }}
                  transition={{ duration: 0.35 }}
                >
                  {ROLES[roleIndex]}
                </motion.p>
              </AnimatePresence>
            </div>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 dark:text-zinc-400 md:text-lg">
              I design and build backend architectures, cloud-native
              applications, and increasingly, AI and LLM-powered systems —
              with a strong grounding in system design, data structures, and
              clean code.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="Portfolio" smooth offset={-64} duration={500} className="btn-primary cursor-pointer">
                View Work
              </Link>
              <a
                href="https://github.com/AakashJha04"
                target="_blank"
                rel="noreferrer"
                className="btn-secondary cursor-pointer"
              >
                <FaGithub />
                GitHub
              </a>
              <a href="/resume.pdf" target="_blank" rel="noreferrer" className="btn-secondary cursor-pointer">
                <HiOutlineDocumentDownload />
                Resume
              </a>
            </div>
          </motion.div>

          {/* RIGHT: PHOTO */}
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
            className="hidden justify-self-center md:flex"
          >
            <div className="relative">
              <div className="absolute -inset-3 -z-10 rounded-3xl border border-indigo-200 dark:border-indigo-500/20" />
              <img
                src={MY_PHOTO}
                alt="Aakash Anand"
                className="w-64 rounded-2xl object-cover shadow-lg md:w-80"
              />
            </div>
          </motion.div>
        </div>
      </div>

      <Link
        to="About"
        smooth
        offset={-64}
        duration={500}
        className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 cursor-pointer flex-col items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-slate-400 md:flex dark:text-zinc-500"
      >
        <span>Scroll</span>
        <motion.span animate={{ y: [0, 6, 0] }} transition={{ duration: 1.6, repeat: Infinity }}>
          <FaArrowDown />
        </motion.span>
      </Link>
    </section>
  );
};

export default Home;
